<template>
	<div class="tree-workspace parentTree">
        <div class="tree-label clickable">
			<i  @click="openWorkspaceChildrens()" class="arrow-icon" :class="{ active: showChildren}"></i>
			<div @click="toggleSelectWorkspace()" class="select-functionality">
				<i class="select-icon square" :class="{ selected: allProjectSelected(), partialSelected: partialProjectSelected()}"></i>
                <div class="tree-label__text">
                    <span class="description-text">Espaço de Trabalho</span>
                    <span class="name-text">{{ workspace.nome }}</span>
                </div>
                
			</div>
            <div class="quantity-items">
                <span class="title-item">Quantidade de Projetos</span>
                <span class="number-string">{{ workspace.qntProjetos }}</span>
            </div>
		</div>

        <b-collapse v-model="showChildren">
			<div class="container-tree-functionality" ref="parent">
                <div class="tree-workspace" v-for="project in workspace.projetos" :key="project.id">
                    <div class="tree-label clickable">
                        <i  @click="openProjectChildrens(project)" class="arrow-icon" :class="{ active: project.projectOpened}"></i>
                        <div @click="toggleSelectProject(project)" class="select-functionality">
                            <i class="select-icon square" :class="{ selected: verifyAllWorkflowProjectSelected(project), partialSelected: partialWorkflowSelected(project), onlyBlocked: project.qntWorkflows == 0}"></i>
                            <div class="tree-label__text">
                                <span class="description-text">Projeto</span>
                                <span class="name-text">{{ project.nome }}</span>
                            </div>
                        </div>
                        <div class="quantity-items">
                            <span class="title-item">Quantidade de Fluxos</span>
                            <span class="number-string">{{ project.qntWorkflows }}</span>
                            
                        </div>
                    </div>

                    <b-collapse v-model="project.projectOpened">
                        <div class="container-tree-functionality" ref="parent">
                            <div class="tree-workspace" v-for="workflow in project.workflows" :key="workflow.id">
                                <div class="tree-label clickable">
                                    <div @click="toggleSelectedWorkflow(workflow)" class="select-functionality">
                                        <i class="select-icon square" :class="{ selected: selectedWorkflows.includes(workflow.id)}"></i>
                                        <div class="tree-label__text">
                                            <span class="description-text">Fluxo</span>
                                            <span class="name-text">{{ workflow.nome }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </b-collapse>
                </div>

			</div>
		</b-collapse>
	</div>
</template>

<script>
import mixins from 'vue-typed-mixins';
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { removeItemFromArrayByValue } from '@/components/helpers';



export default mixins(
	nodeHelpers,
).extend({
	name: 'TreeWorkspace',
	props: {
        workspace: {},
        prevSelectedWorkflows: [],
	},
	data() {
		return {
			showChildren: false,
            listProjects: '',
            isLoadingProject: true,
            isLoadingWorkflow: true,
            selectedWorkflows: [],
		};
	},
	computed: {
		
	},


	methods:{
        verifyWorkflowPrevSelected() {
            const encontrados = [];

            this.workspace?.projetos?.forEach(project => {
                project?.workflows?.forEach(workflow => {
                    if (this.prevSelectedWorkflows.includes(workflow.id)) {
                        encontrados.push(workflow.id);
                        this.selectedWorkflows.push(workflow.id)
                    }
                });
            });
        },
        verifyAllWorkflowProjectSelected(project) {
            return project.workflows.every(workflow =>
                this.selectedWorkflows.includes(workflow.id)
            );
        },
        toggleSelectWorkspace() {
            if (this.allProjectSelected() || this.partialProjectSelected()) {
               this.selectedWorkflows = [];
            } else {

                for (const project of this.workspace.projetos) {
                    if (project.qntWorkflows > 0) {                        
                        const selectedWorkflowIds = project.workflows.map(workflow => workflow.id);
                        this.selectedWorkflows.push(...selectedWorkflowIds);
                    }

                
                }
                    

            }
        },
        partialProjectSelected(){
            return this.workspace.projetos.some(project => {
                if (project.qntWorkflows == 0) return false;
                return project.workflows.some(workflow => this.selectedWorkflows.includes(workflow.id)) && !this.allProjectSelected();
            });
        },
        allProjectSelected() {
            return this.workspace.projetos.every(project => {
                if (project.qntWorkflows == 0) return true;
                return project.workflows.every(workflow => this.selectedWorkflows.includes(workflow.id));
            });
        },
        toggleSelectedWorkflow(workflow) {
            if (this.selectedWorkflows.includes(workflow.id)) {
                removeItemFromArrayByValue(this.selectedWorkflows, workflow.id)
            } else {
                this.selectedWorkflows.push(workflow.id);
            }
        },
        partialWorkflowSelected(project) {
            return project.workflows.some(workflow => this.selectedWorkflows.includes(workflow.id)) && !this.verifyAllWorkflowProjectSelected(project);
        },
        toggleSelectProject(project) {
            if (this.verifyAllWorkflowProjectSelected(project) || this.partialWorkflowSelected(project)) {
                project.workflows = project.workflows.map(workflow => ({
                    ...workflow,
                    selected: false,
                }));
                for (const workflow of project.workflows) {
                    removeItemFromArrayByValue(this.selectedWorkflows, workflow.id);
                }
            } else {
                project.workflows = project.workflows.map(workflow => ({
                    ...workflow,
                    selected: true,
                }));
                const selectedWorkflowIds = project.workflows.map(workflow => workflow.id);
                this.selectedWorkflows.push(...selectedWorkflowIds);
            }
        },
        async openWorkspaceChildrens() {
			this.showChildren = !this.showChildren;
        },
        async openProjectChildrens(project) {
            if (project.qntWorkflows == 0) return;
            project.projectOpened = !project.projectOpened;
        },
        toggleShowChildren() {
			this.showChildren = !this.showChildren;
		},
	},
	watch: {
	},
	mounted() {
        this.verifyWorkflowPrevSelected();
        this.$root.$on('sendDataWorkflow', () => {
            this.$emit('sendWorkflow', this.selectedWorkflows);
		});
        
	},

	beforeDestroy() {
        this.$root.$off('sendDataWorkflow');
	},
});
</script>

<style scoped lang="scss">
.tree-workspace {
	position: relative;
	margin: 8px 0 0px 50px;
	&.parentTree {
		max-height: initial;
		margin: 0 0 16px 0;

        &::after {
            content: '';
            display: block;
            width: 100%;
            background: #223049;
            border: 1px solid #425579;
            box-shadow: 2px 2px 4px 0px #0000008F;
            border-radius: 4px;
            height: 70px;
            left: 10px;
            top: 10px;
            z-index: 0;
            position: absolute;
        }

		& > .tree-label {
            z-index: 9;
            margin-bottom: 10px;
			font-size: 16px;
			background: #273A5B;
			border: 1px solid #677CA1;

			&:before {
				display: none;
			}
		}
	}


	.container-tree-functionality {
		position: relative;
        padding: 10px 0;

		.tree-functionality:last-child {

			& > .tree-label {
				&:before {
					background: url('./../assets/curvedLineFunctionalities.svg');
					background-position: center;
					background-repeat: no-repeat;
					background-size: cover;
					background-size: 100%;
					width: 32px;
					left: -33px;
					border-left: 2px solid transparent;
					height: 28px;
					top: -9px;
				}
			}

			&:after {
				content: '';
				width: 20px;
				left: -47px;
				top: 13px;
				height: calc(100% - 10px);
				display: block;
				background: #1c2638;
				position: absolute;
			}
		}


		&:before {
			content: '';
			width: 1.5px;
            top: 0px;
			left: 20px;
			height: calc(100% - 44px);
			display: block;
			background: #4A638F;
			position: absolute;
		}



		&.oneChild {
			&:before {
				display: none;
			}
		}
	}

	.tree-label {
		padding: 0px 32px 0 9px;
		font-size: 14px;
		font-weight: 500;
		background: #223049;
		border: 1px solid #4A638F;
		box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.32);
		border-radius: 4px;
		display: flex;
		align-items: center;
		column-gap: 25px;
        height: 70px;
		position: relative;

        &:after {
            content: '';
            width: 1px;
            height: 24px;
            background: #4A638F;
            position: absolute;
            left: 42px;
            display: block;
            top: 50%;
            transform: translateY(-50%);
        }

        .quantity-items {
            margin-left: auto;
            display: flex;
            flex-direction: column;
            position: relative;

            &::after {
                content: '';
                width: 1px;
                height: 24px;
                background: #34476A;
                position: absolute;
                left: -15px;
                top: 50%;
                transform: translateY(-50%);
            }

            .title-item {
                color: #FFFFFFA3;
                font-size: 13px;

            }
            .number-string {
                color: #FFFFFFE0;
                font-size: 14px;
            }

        }

        &__text {
            display: flex;
            flex-direction: column;
            .description-text {
                font-size: 13px;
                color: #FFFFFFA3;
            }
            .name-text {
                font-size: 14px;
                color: #FFFFFFE0;
            }
        }

		&.highlightLabel {
			background: linear-gradient(0deg, rgba(0, 195, 221, 0.04), rgba(0, 195, 221, 0.04)), #223049 !important;
			border: 1px solid #00C3DD !important;
			color: #00C3DD !important;
		}

		&:before {
			content: '';
			width: 29px;
			left: -30px;
			height: 2px;
			display: block;
			background: #4A638F;
			position: absolute;
		}

		.select-functionality {
			display: flex;
			column-gap: 16px;
			width: initial;
			align-items: center;
		}

		.arrow-icon {
			background-image: url('./../assets/cardArrow.svg');
			background-position: center;
			background-repeat: no-repeat;
			width: 24px;
			height: 24px;
			transform: rotate(90deg);
			transition: 0.2s transform;

			&.active {
				background: rgba(0, 195, 221, 0.08);
				border-radius: 4px;
				background-image: url('./../assets/arrowIconBlue.svg');
				background-position: center;
				background-repeat: no-repeat;
				transform: rotate(0deg);
			}
		}

		.select-icon {
			margin: 0;
		}
		&.clickable {
			cursor: pointer;
		}
	}
}
</style>
